import React, { Component } from "react";

import SharedUserView from "./SharedUserView";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import GroupIcon from '@material-ui/icons/Group';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';

//import AccountTreeIcon from '@mui/icons-material/AccountTree';
//import GroupIcon from '@mui/icons-material/Group';
//import GroupsIcon from '@mui/icons-material/Groups';

import { Link } from 'react-router-dom';


class UserRow extends Component {
	constructor() {
		super();
		this.handleClick = this.handleClick.bind(this);
		this.setSharedUsersView = this.setSharedUsersView.bind(this);
		this.deleteUser = this.deleteUser.bind(this);
		this.enableUser = this.enableUser.bind(this);
		this.switchUserState = this.switchUserState.bind(this);
	}
	
	handleClick() {
		this.props.actions(this.props.id, this.props.task, this.props.state);
	}
	
	setSharedUsersView(id, userList){
		this.props.setSharedUsersView(id, userList);
	}
	
	deleteUser(){
		this.props.switchUserState(this.props.id, false);
	}
	
	enableUser(){
		this.props.switchUserState(this.props.id, true);
	}
	
	switchUserState(){
		if(this.props.enabled){
			return <HighlightOffIcon onClick={() => { this.deleteUser(); }} style={{fontSize: "21px", color: "#b26d6d", cursor: "pointer"}}/>
		}else{
			return <FlipCameraAndroidIcon onClick={() => { this.enableUser(); }} style={{fontSize: "21px", color: "#339a54", cursor: "pointer"}}/>
		}
	}
	
	render() {
		let rol = this.props.role;
		let formatedName = this.props.username;
		if(!this.props.enabled){
			formatedName=<span className="disabledUser">{this.props.username}</span>;
		}
		if(this.props.id == 33 || this.props.id == 297 || this.props.id == 13 || this.props.id == 18 ){
			rol += ", REVISOR";
		}
		let sharedUserView = "";
		if(this.props.role === "CUSTOMER" && this.props.relatedUsers!=null){
			sharedUserView = <SharedUserView
								userId = {this.props.id}
								relatedUsers = {Object.values(this.props.relatedUsers)}
								setSharedUsersView = {this.setSharedUsersView}
								activeUserList = {this.props.sharedUsersView}/>
		}
		return (
			<tr key={this.props.id}>
			<td>{this.props.id}</td>
			<td>{formatedName}</td>
			<td>{this.props.fullname}</td>
			<td>{this.props.sharedUsersViewDescription}</td>
			<td>{rol}</td>
			<td>{this.props.customerName}</td>
			<td><Link to={`/userForm/${this.props.id}/${this.props.customerId}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59424;</Icon></Link> {sharedUserView} {this.switchUserState()}</td>
			</tr>
		);
	}
}

export default UserRow;